import { Component, Vue, Watch } from 'vue-property-decorator'
import DefaultLayout from '@/components/Layouts/Default'
import { VirtualList } from '@/components/Game/Matchup'
import GameFooter from '@/components/Game/Footer'
import { FormatCurrency } from '@/utils/GameUtils'

@Component
export class VirtualLobby extends Vue {

  private created() {
    this.$store.dispatch('SET_CLASSIC', true)
  }

  private destroyed() {
    this.$store.dispatch('SET_CLASSIC', false)
  }

  render(h: any) {

    let loader: JSX.Element | null = null
    if (this.$store.getters.LOADING) {
      loader = <div class='lds-grid'><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    }

    return (
        <DefaultLayout>
            <div slot='navigation'>
              <h1 class='navigation-title'>Virtual</h1>
              <router-link class='navigation-link home' to='/home'>Home</router-link>
              <p class='navigation-user'>{this.$store.getters.USERNAME}</p>
              <router-link class='navigation-balance' to='/account'>{`${FormatCurrency(this.$store.getters.BALANCE)}`}</router-link>
            </div>
            
            {loader}
            <VirtualList></VirtualList>
            <GameFooter></GameFooter>
        </DefaultLayout>
    );
  }
}
